import CryptoJS from "crypto-js";
const DECRYPTION_KEY = process.env.DECRYPTION_KEY ? process.env.DECRYPTION_KEY : "f5ea9CO051-9N4b6-4FIA699";

function decryptData(data) {
  // receive String
  const bytes = CryptoJS.AES.decrypt(data, DECRYPTION_KEY);
  const decryptedCpf = bytes.toString(CryptoJS.enc.Utf8);
  return decryptedCpf;
}

export default {
  decryptData,
};
